var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('icon',{attrs:{"icon":_setup.faCheck}}):_c('icon',{attrs:{"icon":_setup.faTimes}})
}
var staticRenderFns = []

export { render, staticRenderFns }